// extracted by mini-css-extract-plugin
export var divider = "_mc-0";
export var labelWrapper = "_mc-2";
export var lineSvg = "_mc-1";